import {FC, useMemo} from 'react'
import {KTSVG} from '_metronic/helpers'
import _truncate from 'lodash/truncate'
import trim from 'lodash/trim'
import toString from 'lodash/toString'
import toLower from 'lodash/toLower'

interface CustomerNameProps {
  firstName?: string
  lastName?: string
  isGuest?: boolean
  hasWineClub?: boolean
  customerName?: string
  truncate?: {
    length: number
  }
}

const CustomerName: FC<CustomerNameProps> = ({
  firstName,
  lastName,
  isGuest = false,
  hasWineClub = false,
  customerName,
  truncate,
}) => {
  const customerLabel = useMemo(() => {
    const labelMap = {
      fullName: firstName && lastName ? `${firstName} ${lastName}` : null,
      firstName: firstName && !lastName ? firstName : null,
      lastName: !firstName && lastName ? lastName : null,
      customName: customerName ? customerName : null,
      guest: isGuest ? 'Guest' : null,
    }

    const label = Object.values(labelMap).find((value) => value) || ''
    const capitalize = (label: string) =>
      label
        .split(' ')
        .map((word) => {
          const labelWord = word.toLowerCase()
          return labelWord.charAt(0).toUpperCase() + labelWord.slice(1)
        })
        .join(' ')
    const CustomerLabel = capitalize(label)

    if (truncate?.length) {
      return _truncate(CustomerLabel, {length: truncate.length})
    }

    return CustomerLabel
  }, [firstName, lastName, customerName, isGuest, truncate])

  return (
    <>
      {customerLabel}
      {hasWineClub && (
        <span className='svg-icon svg-icon-1 ms-2'>
          <KTSVG
            path='/media/icons/corksy/crown.svg'
            className='svg-icon-warning svg-icon-2 p-0 m-0'
          />
        </span>
      )}
    </>
  )
}

interface CustomerEmailProps {
  email: string
}

const CustomerEmail: FC<CustomerEmailProps> = ({email}) => <>{toLower(trim(email))}</>
interface PhoneProps {
  phone: any
}
const CustomerPhone: FC<PhoneProps> = ({phone}) => {
  const phoneNumber = useMemo(() => {
    const replaceNum = toString(phone).replace(/\D/g, '')
    if (replaceNum.length === 10) {
      return `(${replaceNum.slice(0, 3)}) ${replaceNum.slice(3, 6)}-${replaceNum.slice(6)}`
    }
    return replaceNum
  }, [phone])

  return <>{phoneNumber}</>
}
export {CustomerName, CustomerEmail, CustomerPhone}
